import React from 'react';
import { useIntl } from 'react-intl';

export default function NotFoundPage(){
    const intl = useIntl();
    return (<>
                <h1 style={{marginTop:'200px',textAlign:'center'}}>{intl.formatMessage({ id: "404-not-found" })}</h1>
            </>
           );
}